<template>
  <v-card>
    <v-toolbar flat>
      <span class="headline">Two-Factor Authentication</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text
      class="sms-card-span">
      Please select how to receive TFA verification code
    </v-card-text>
    <div>
      <v-card>
        <v-row style="margin: 0 0 0 12px">
          <v-col cols="9">
            <v-radio-group v-model="targetOptionData.targetStatus" class="sms-class">
              <v-flex lg3>
                <v-radio
                  color="primary"
                  :label="targetOptionData.emailOption.label"
                  :value="targetOptionData.emailOption.status"
                ></v-radio>
              </v-flex>
<!--              <v-flex lg4>
                <v-radio
                  color="primary"
                  :label="targetOptionData.phoneOption.label"
                  :value="targetOptionData.phoneOption.status"
                ></v-radio>
              </v-flex>-->
            </v-radio-group>
          </v-col>
          <v-col cols="3">
            <v-btn
              color="green darken-1"
              class="width-full height-full align-center"
              text
              :disabled="send.display"
              @click="sendVerificationInfo"
            >
              Send
              <span v-if="send.timeShow">{{ send.timeText }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div>
      <v-card flat>
        <v-card-text>
          <v-row>
            <v-col cols="9">
              <v-row>
                <v-col cols="2">
                  <div class="border-container"><input :disabled="verify.display" v-model.trim.number="input0" ref="input0"
                                                       @keydown.8="deleteValue('input0','input0')" v-mask="mask"/></div>
                </v-col>
                <v-col cols="2">
                  <div class="border-container"><input :disabled="verify.display" v-model.trim.number="input1" ref="input1"
                                                       @keydown.8="deleteValue('input1','input0')" v-mask="mask"/></div>
                </v-col>
                <v-col cols="2">
                  <div class="border-container"><input :disabled="verify.display" v-model.trim.number="input2" ref="input2"
                                                       @keydown.8="deleteValue('input2','input1')" v-mask="mask"/></div>
                </v-col>
                <v-col cols="2">
                  <div class="border-container"><input :disabled="verify.display" v-model.trim.number="input3" ref="input3"
                                                       @keydown.8="deleteValue('input3','input2')" v-mask="mask"/></div>
                </v-col>
                <v-col cols="2">
                  <div class="border-container"><input :disabled="verify.display" v-model.trim.number="input4" ref="input4"
                                                       @keydown.8="deleteValue('input4','input3')" v-mask="mask"/></div>
                </v-col>
                <v-col cols="2">
                  <div class="border-container"><input :disabled="verify.display" v-model.trim.number="input5" ref="input5"
                                                       @keydown.8="deleteValue('input5','input4')" v-mask="mask"/></div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-btn
                :loading="verify.isloading"
                color="green darken-1"
                class="width-full height-full align-center"
                text
                @click="verifyTfaCaptcha"
                :disabled="verify.display"
              >
                Verify
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import { Tool, Popup } from '@/util/index'
import { TfaApi } from '@/api/v4/auth'
import { AuthApi } from '@/api/pandaria'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'tfa-verification-dialog',
  props: {
    verification: Object
  },
  data () {
    return {
      targetOptionData: {
        targetStatus: null,
        emailOption: {
          status: 2,
          label: 'Email'
        },
        phoneOption: {
          status: 1,
          label: 'Phone'
        }
      },
      mask: '#',
      input1: '',
      input2: '',
      input3: '',
      input0: '',
      input4: '',
      input5: '',
      verificationType: {
        number: 1,
        letter: 2,
        numberAndLetter: 3
      },
      captcha: '',
      send: {
        display: false,
        timer: null,
        timeLimit: 60,
        timeText: '60s',
        timeShow: false
      },
      verify: {
        display: true,
        isLoading: false
      },
      account: ''
    }
  },
  mounted () {
    this.getAccount(this.verification.token)
  },
  watch: {
    input0 (value) {
      if (tool.isNotEmpty(value)) {
        this.$refs.input1.focus()
      }
    },
    input1 (value) {
      if (tool.isNotEmpty(value)) {
        this.$refs.input2.focus()
      }
    },
    input2 (value) {
      if (tool.isNotEmpty(value)) {
        this.$refs.input3.focus()
      }
    },
    input3 (value) {
      if (tool.isNotEmpty(value)) {
        this.$refs.input4.focus()
      }
    },
    input4 (value) {
      if (tool.isNotEmpty(value)) {
        this.$refs.input5.focus()
      }
    }
  },
  methods: {
    deleteValue (inputValue, previousItem) {
      if (this[inputValue].toString().length > 0) {
        this[inputValue] = ''
      } else {
        this.$nextTick(() => {
          this[inputValue] = ''
          this.$refs[previousItem].focus()
        })
      }
    },
    hideDialog () {
      this.verification.display = false
      this.$eventBus.$emit('reLoading')
    },
    sendVerificationInfo () {
      const $this = this
      const inputData = {
        to: $this.targetOptionData.targetStatus === 2 ? $this.account.email : $this.account.telephone,
        method: $this.targetOptionData.targetStatus,
        type: $this.verificationType.number,
        length: 6
      }
      if ($this.targetOptionData.targetStatus === 1 && tool.isEmpty($this.account.telephone)) {
        return popup.popupForWarning('Please complete your phone information')
      }
      if (tool.isEmpty($this.targetOptionData.targetStatus)) {
        return popup.popupForWarning('Please select the verification method')
      }
      TfaApi.sendTfaCaptcha(inputData, function (data) {
        popup.popupForSuccess()
        $this.send.display = true
        $this.verify.display = false
        $this.send.timeShow = true
        $this.send.timer = setInterval(function () {
          $this.sendTimeDown()
        }, 1000)
      }, function (result) {
        popup.popupForError(result.message)
      })
    },
    verifyTfaCaptcha () {
      const number = '' + this.input0 + this.input1 + this.input2 + this.input3 + this.input4 + this.input5
      const $this = this
      const inputData = {
        captcha: number
      }
      if (tool.isEmpty(number)) {
        return popup.popupForWarning('Please enter the verification code')
      }
      TfaApi.verifyTfaCaptcha(inputData, function (data) {
        $this.verify.isloading = true
        window.getApp.$emit('APP_LOGIN_SUCCESS')
      }, function (result) {
        popup.popupForError(result.message)
        $this.verify.isloading = false
      })
    },
    sendTimeDown () {
      const _this = this
      if (_this.send.timeLimit - 1 < 0) {
        clearInterval(this.send.timer)
        _this.send.display = false
        _this.send.timer = null
        _this.send.timeLimit = 60
        _this.send.timeText = '60s'
        _this.send.timeShow = false
      } else {
        _this.send.timeText = '(' + (_this.send.timeLimit - 1) + 's)'
        _this.send.timeLimit = _this.send.timeLimit - 1
      }
    },
    getAccount (accessToken) {
      const $this = this
      AuthApi.getAccount(
        accessToken,
        function (result) {
          $this.account = result
        }
      )
    }
  }
}

</script>

<style lang="css" scoped>

.sms-card-span {
  margin-top: 12px;
}

.border-container {
  border: 1px solid grey;
  height: 50px;
  border-radius: 5px;
}

.border-container input {
  text-align: center;
  display: block;
  width: 100%;
  height: 100%;
  font-size: 16px;
}

input::-webkit-inner-spin-button{
  -webkit-appearance: none !important;
  margin: 0;
}

</style>
